import { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "Come ricevo il mio piano dopo l'acquisto?",
    a: "Dopo il pagamento sicuro su Stripe riceverai immediatamente l'email con i dati per scaricare l'app e compilare il questionario iniziale di anamnesi. Da lì costruisco il tuo percorso su misura.",
  },
  {
    q: "Il programma è adatto anche se parto da zero?",
    a: "Assolutamente sì. Il piano viene calibrato sul tuo livello attuale, con video esplicativi passo-passo per ogni singolo movimento. Che tu sia principiante o atleta esperto, la scheda è costruita su di te.",
  },
  {
    q: "Posso allenarmi sia a casa che in palestra?",
    a: "Sì, strutturo la scheda in base alle attrezzature a tua disposizione, massimizzando lo stimolo in ogni contesto: corpo libero, manubri o sala pesi completa.",
  },
  {
    q: "Il coaching è solo online o anche di persona?",
    a: "Il servizio è pensato per essere seguito interamente online in tutta Italia tramite app e chat. Per chi si trova in zona è possibile valutare anche sessioni di persona: scrivimi dalla pagina Contatti per i dettagli.",
  },
  {
    q: "Quali metodi di pagamento accettate?",
    a: "Tutti i pagamenti passano da Stripe: carte di credito e debito (Visa, Mastercard, American Express), Apple Pay e Google Pay, in modo sicuro e crittografato.",
  },
  {
    q: "Posso recedere dopo l'acquisto?",
    a: "Sì: hai 14 giorni per esercitare il diritto di recesso secondo la normativa europea, come descritto nella pagina Diritto di Recesso. Se il servizio personalizzato è già stato erogato su tua richiesta espressa, le condizioni specifiche sono indicate nei Termini di Vendita.",
  },
  {
    q: "Il piano alimentare è una dieta medica?",
    a: "No: il programma alimentare è un supporto nutrizionale generale legato all'allenamento e non sostituisce il parere di un medico o di un dietologo. In presenza di patologie, consulta sempre un professionista sanitario.",
  },
];

const FaqItem = ({ faq, index }) => {
  const [open, setOpen] = useState(index === 0);
  return (
    <div data-testid={`faq-item-${index}`} className="rounded-xl bg-[#140b24] border border-[#2d1b4e] overflow-hidden">
      <button data-testid={`faq-question-${index}`} onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-4 p-6 text-left">
        <span className="text-base font-bold text-white">{index + 1}. {faq.q}</span>
        <ChevronDown className={`w-5 h-5 text-[#a020f0] shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <p data-testid={`faq-answer-${index}`} className="px-6 pb-6 text-sm text-[#cbd5e1] leading-relaxed">
          {faq.a}
        </p>
      )}
    </div>
  );
};

export const FaqSection = () => (
  <section id="faq" data-testid="faq-section" className="py-24 px-6 bg-[#0d0718]">
    <div className="max-w-4xl mx-auto">
      <div className="text-center mb-16">
        <span className="text-xs uppercase tracking-widest text-[#a020f0] font-bold mono-font">Guida all'acquisto</span>
        <h2 className="display-font text-3xl md:text-5xl uppercase text-white mt-2">Domande Frequenti</h2>
      </div>
      <div className="space-y-4">
        {FAQS.map((f, i) => <FaqItem key={i} faq={f} index={i} />)}
      </div>
    </div>
  </section>
);
